import React from 'react';
import { CheckCircleIcon, TruckIcon } from 'lucide-react';
interface VendorCardProps {
  vendor: {
    id: string;
    name: string;
    rating: number;
    price: number;
    originalPrice: number;
    condition: string;
    deliveryTime: string;
    inStock: boolean;
  };
}
export const VendorCard = ({
  vendor
}: VendorCardProps) => {
  return <div className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow" data-id="element-1348">
      <div className="flex justify-between" data-id="element-1349">
        <div data-id="element-1350">
          <h4 className="font-medium text-lg" data-id="element-1351">{vendor.name}</h4>
          <div className="flex items-center mt-1" data-id="element-1352">
            <div className="flex items-center bg-gray-100 px-2 py-1 rounded-md" data-id="element-1353">
              <span className="text-sm font-medium text-gray-800" data-id="element-1354">
                {vendor.rating}
              </span>
              <span className="text-sm text-gray-600" data-id="element-1355">/5.0</span>
            </div>
            <div className="ml-2 flex items-center text-sm text-gray-600" data-id="element-1356">
              <CheckCircleIcon className="h-4 w-4 text-green-500 mr-1" data-id="element-1357" />
              <span data-id="element-1358">Verified Seller</span>
            </div>
          </div>
          <div className="flex items-center mt-2 text-sm text-gray-600" data-id="element-1359">
            <TruckIcon className="h-4 w-4 mr-1" data-id="element-1360" />
            <span data-id="element-1361">Delivery in {vendor.deliveryTime}</span>
          </div>
          <div className="mt-1 text-sm text-gray-600" data-id="element-1362">
            Condition: <span className="font-medium" data-id="element-1363">{vendor.condition}</span>
          </div>
        </div>
        <div className="flex flex-col items-end" data-id="element-1364">
          <div className="text-2xl font-bold text-gray-900" data-id="element-1365">
            ${vendor.price}
            <span className="text-sm align-top" data-id="element-1366">.00</span>
          </div>
          <div className="text-sm text-gray-500 line-through" data-id="element-1367">
            ${vendor.originalPrice}.00
          </div>
          <button className="mt-2 bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors" data-id="element-1368">
            Add
          </button>
        </div>
      </div>
    </div>;
};